import PropTypes from 'prop-types';
import SiteHistory from './components/SiteHistory';
import ReimbursementDue from './components/ReimbursementDue';
import EnergyReimbursement from './components/EnergyReimbursement'
import ProfitShareUtilisation from './components/ProfitShareUtilisation'

const FfPsBs = ({statement}) => {

  const reimbursementDue = statement.data.elecReimbursementDay + statement.data.elecReimbursementNight;

  return (
    <div>
      <SiteHistory siteLiveDate={statement.data.siteLiveDate} liveDaysInQ={statement.data.liveDaysInQ}/>
      <EnergyReimbursement data={statement.data}/>
      <ProfitShareUtilisation data={statement.data} />      
      <ReimbursementDue reimbursementDue={reimbursementDue}/>
    </div>
  )
}

export default FfPsBs;

FfPsBs.propTypes = {
  statement: PropTypes.object.isRequired,
};